import { useTranslation } from "react-i18next"

import { cn } from "@/lib/utils"
import { isLegalAddress, unitTypeLabel } from "@/lib/contract-utils"
import { Label } from "@/components/ui/label"
import { RadioGroupItem } from "@/components/ui/radio-group"
import { Contract } from "@/types/contract"
import { Facility } from "@/types/warehouse"

export function ContractsMiniGroup({ facility, contracts }: { facility: Facility, contracts: Contract[] }) {
  const { t } = useTranslation()

  return (
    <div>
      <div className="mb-4">
        <div className="text-[18px] leading-[26px] text-foreground">
          {facility.properties?.find(property => property.code === "display_name")?.value ?? facility.name}
        </div>
      </div>

      <div className="-mx-4 flex sm:gap-4 gap-2 overflow-x-auto px-4 pb-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:mx-0 sm:grid sm:grid-cols-3 sm:overflow-visible sm:px-0 sm:pb-0">
        {contracts.map(contract => {
          const itemId = `contract-mini-${contract.id}`

          return (
            <div key={contract.id} className="relative shrink-0 sm:shrink">
              <RadioGroupItem id={itemId} value={String(contract.id)} className="peer sr-only" />
              <Label
                htmlFor={itemId}
                className={cn(
                  "flex h-[125px] w-[150px] shrink-0 cursor-pointer flex-col items-start justify-between sm:rounded-[8px] rounded-[4px] border-2 border-transparent bg-background sm:p-4 p-3 transition-colors",
                  "sm:aspect-[199/162] sm:h-auto sm:w-full sm:shrink",
                  "hover:bg-[#ECF0F6] peer-data-[state=checked]:border-brand peer-data-[state=checked]:bg-card peer-data-[state=checked]:hover:bg-card"
                )}
              >
                <span className="text-[16px] leading-[22px] font-medium text-foreground">
                  {isLegalAddress(contract) ? t("contracts.legalAddress") : unitTypeLabel(contract)}
                </span>

                <span className="sm:text-[28px] text-[24px] sm:leading-[34px] leading-[30px] font-semibold text-foreground">
                  {contract.unitItem?.code ?? contract.unit}
                </span>
              </Label>
            </div>
          )
        })}
      </div>
    </div>
  )
}
